// src/components/Sponsors.js
import React from "react";
import "./Sponsors.css";
import AmpaSponsor from "./AmpaSponsor";

import AUIBAR from "../images/sponsors/african_union.png";
import woh from "../images/sponsors/woh.png";
import iav from "../images/sponsors/iav.png";
import um6ss from "../images/sponsors/um6ss.png";
import fao from "../images/sponsors/FAO.png";
import ministere from "../images/sponsors/ministere.png";
import wts from "../images/sponsors/wts.png";

import A2V from "../images/sponsors/A2V.png";
import CIVME from "../images/sponsors/CIVME.jpeg";


const Sponsors = () => {
  // Placeholders for the Sponsors
  const sponsorsList = [
        
                {
      name: "IAV HASSAN II",
      title: null,
      description: null,
      image: iav,
    },


    {
      name: "UM6SS",
      title: null,
      description: null,
      image: um6ss,
    },

    {
      name: "Ministère de l'Agriculture, de la Pêche Maritime, du Développement Rural et des Eaux et Forêts",
      title: null,
      description: null,
      image: ministere,
    },


    {
      name: "AU-IBAR",
      title: null,
      description: null,
      image: AUIBAR,
    },
    {
      name: "Woah Africa",
      title: null,
      description: null,
      image: woh,
    },
    {
      name: "FAO",
      title: null,
      description: null,
      image: fao,
    },

        {
      name: "2A2V-E",
      title: null,
      description: null,
      image: A2V,
    },
     {
      name: "AAVMC",
      title: null,
      description: null,
      image: CIVME,
    },

  ];

  return (
    <div className="sponsors-section">
      <h1 className="sponsors-title">Our Sponsors</h1>
      <div className="sponsors-container">
        {sponsorsList.map((sponsor, index) => (
          <div key={index} className="sponsors-card">
            <div
              className="sponsors-image"
              style={{ backgroundImage: `url(${sponsor.image})` }}
            >
              {sponsor.description && (
                <div className="sponsors-hover">
                  <p>{sponsor.description}</p>
                </div>
              )}
            </div>
            <h3 className="sponsors-name">{sponsor.name}</h3>
            <p className="sponsors-title-small">{sponsor.title}</p>
          </div>
        ))}
      </div>

      <AmpaSponsor />
    </div>
  );
};

export default Sponsors;